import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
/**
 * Represents the color gradient for the gainers and contributors in the contributors/detractors module
 */
export const POSITIVE_CONSTITUENTS_COLOR = [
    'bg-positive-1',
    'bg-positive-2',
    'bg-positive-3',
    'bg-positive-4',
    'bg-positive-5',
    'bg-positive-6',
    'bg-positive-7',
    'bg-positive-8',
];
/**
 * Represents the color gradient for the losers and detractors in the contributors/detractors module
 */
export const NEGATIVE_CONSTITUENTS_COLOR = [
    'bg-negative-1',
    'bg-negative-2',
    'bg-negative-3',
    'bg-negative-4',
    'bg-negative-5',
    'bg-negative-6',
    'bg-negative-7',
    'bg-negative-8',
];
/**
 * Represents the length of NEGATIVE_CONSTITUENTS_COLOR and POSITIVE_CONSTITUENTS_COLOR which is the number of gradients
 */
export const NUMBER_OF_COLOR_GRADIENTS = 8;
/**
 * Performance periodicity options available in attribution components
 */
export const ABSOLUTE_ATTRIBUTION_PERIODICITY_OPTIONS = [
    { label: '1d', value: PerformancePeriodicity.ONE_DAY, disabled: false },
    { label: '5d', value: PerformancePeriodicity.FIVE_DAYS, disabled: false },
    { label: '1m', value: PerformancePeriodicity.ONE_MONTH, disabled: false },
    { label: '3m', value: PerformancePeriodicity.THREE_MONTHS, disabled: false },
    { label: '6m', value: PerformancePeriodicity.SIX_MONTHS, disabled: false },
    { label: 'YTD', value: PerformancePeriodicity.YTD, disabled: false },
    { label: '1y', value: PerformancePeriodicity.ONE_YEAR, disabled: false },
    { label: '5y', value: PerformancePeriodicity.FIVE_YEARS, disabled: false },
    { label: '10y', value: PerformancePeriodicity.TEN_YEARS, disabled: false },
    { label: 'MAX', value: PerformancePeriodicity.MAX, disabled: false },
];
export const RELATIVE_ATTRIBUTION_PERIODICITY_OPTIONS = [
    { label: '1d', value: PerformancePeriodicity.ONE_DAY, disabled: false },
    { label: '5d', value: PerformancePeriodicity.FIVE_DAYS, disabled: false },
    { label: '1m', value: PerformancePeriodicity.ONE_MONTH, disabled: false },
    { label: '3m', value: PerformancePeriodicity.THREE_MONTHS, disabled: false },
    { label: '6m', value: PerformancePeriodicity.SIX_MONTHS, disabled: false },
    { label: 'YTD', value: PerformancePeriodicity.YTD, disabled: false },
    { label: '1y', value: PerformancePeriodicity.ONE_YEAR, disabled: false },
    { label: '5y', value: PerformancePeriodicity.FIVE_YEARS, disabled: false },
    { label: '10y', value: PerformancePeriodicity.TEN_YEARS, disabled: false },
    { label: '20y', value: PerformancePeriodicity.TWENTY_YEARS, disabled: false },
];
// asOfDate constants
export const AS_OF_DATE_DAILY = 'daily';
export const AS_OF_DATE_MONTH_END = 'month_end';
export const AS_OF_DATE_QUARTER_END = 'quarter_end';
export const AS_OF_DATE_CUSTOM = 'custom';
export const AS_OF_DATE_DROPDOWN_CONFIG = {
    list: [
        {
            disabled: false,
            label: 'Daily',
            type: 'option',
            value: AS_OF_DATE_DAILY,
        },
        {
            disabled: false,
            label: 'Month End',
            type: 'option',
            value: AS_OF_DATE_MONTH_END,
        },
        {
            disabled: false,
            label: 'Quarter End',
            type: 'option',
            value: AS_OF_DATE_QUARTER_END,
        },
        {
            disabled: false,
            label: 'Custom',
            type: 'option',
            value: AS_OF_DATE_CUSTOM,
        },
    ],
};
export const DIRECT_HOLDINGS = 'direct_holdings';
export const INTERMEDIARY_HOLDINGS = 'invested_holdings';
export const UNDERLYING_HOLDINGS = 'underlying_holdings';
export const HOLDINGS_LAYER_DROPDOWN_CONFIG = {
    list: [
        {
            label: 'Holdings',
            value: DIRECT_HOLDINGS,
        },
        {
            label: 'Underlying Holdings',
            type: 'option',
            value: UNDERLYING_HOLDINGS,
        },
    ],
};
